import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { setLayerMetadata } from '../../layerMetadata'
import { findFeature } from '../../findFeature'

import { findOrderMarker } from './findOrderMarker'
import { updateOrderFeature } from './updateOrderFeature'

const nonblockingRender = createNonBlockingRenderByTime()

export const changelogUpdateOrderFeatures = async (
  layer: VectorLayer<VectorSource>,
  markers: Record<string, uui.domain.ui.map.markers.Order>,
  mapStyles: uui.domain.ui.map.markers.MapStyles['order'],
  selection: Set<string>,
  selectedOrderIds: Set<string>,
  markerIds: IterableIterator<string>,
) => {
  nonblockingRender.reset()

  for (const markerId of markerIds) {
    await nonblockingRender.next()

    const marker = findOrderMarker(markers, markerId)
    if (!marker) {
      console.warn(
        `Trying to update Order feature with lat-lng: ${markerId} but no marker exist on the map`,
      )
      continue
    }

    const feature = findFeature(layer, marker.id)

    if (!feature) {
      throw new Error(
        `Trying to update Order feature with lat-lng: ${marker.id} but no feature exist on the map`,
      )
    }

    const selected = selection.has(markerId)
    updateOrderFeature(mapStyles, marker, feature, selectedOrderIds, selected)
  }

  // update the stored collection
  setLayerMetadata(layer, 'selection', selection)
}
